export default __webpack_public_path__ + "static/media/assisted-ic-light.e1c5352c.svg";